<div [style.height]="heightAndWidth" [style.width]="heightAndWidth" class="lock-icon light-lock"></div>
